import * as i0 from "@angular/core";
var BaseService = /** @class */ (function () {
    function BaseService() {
    }
    BaseService.ngInjectableDef = i0.defineInjectable({ factory: function BaseService_Factory() { return new BaseService(); }, token: BaseService, providedIn: "root" });
    return BaseService;
}());
export { BaseService };
